export default __webpack_public_path__ + "static/media/wlogo.9911e385.png";